export default {
	name: 'layout-home',
	path: '/',
	redirect: '/home',
	children: [
		{
			name: 'home',
			path: '/home',
			meta: {
				title: '校园管理平台',
				icon: 'icon-home'
			},
			component: () => import(/* webpackChunkName: "home" */ '@/views/home')
		}
	]
};
